module.exports = "\n\n<form [formGroup]=\"form\" [ngClass]=\"{ 'invisible': !visible }\">\n  <div form-host></div>\n  <div class=\"form-footer d-flex justify-content-end\" *ngIf=\"showHud\">\n    <app-button label=\"Aceptar\" [disabled]=\"form.invalid\" (click)=\"complete()\"></app-button>\n  </div>\n</form>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/core/component/form-child/form-child.component.html
// module id = 1107
// module chunks = 0